import memoize from '@jetbrains/ring-ui/components/global/memoize'
import {CustomItem} from '@jetbrains/ring-ui/components/tabs/custom-item'
import type {TabProps} from '@jetbrains/ring-ui/components/tabs/tab'
import {Tab} from '@jetbrains/ring-ui/components/tabs/tabs'
import classNames from 'classnames'
import * as React from 'react'

import {stringifyId} from '../../../types'
import type {TabId} from '../../../types'
import {parseTabTitle} from '../../../utils/tabs'
import ClassicTabMammoth from '../ClassicTabMammoth/ClassicTabMammoth'
import Link from '../Link/Link'

import styles from './OverviewTab.css'

type Props = TabProps & {
  isClassic?: boolean
  unlimitedWidth?: boolean
}
type CollapsibleTabProps = {
  id: TabId
  href?: string
  title: string
}
const getTitle = memoize((title: string) =>
  // eslint-disable-next-line react/display-name
  memoize((counter: string) => (isSelected: boolean) => (
    <span>
      <span data-test="tab" data-tab-title={title} data-selected={isSelected}>
        {title}
        {counter !== '' && (
          <span data-test-tab-counter className={styles.counter}>
            {counter}
          </span>
        )}
      </span>
    </span>
  )),
)
export const renderTitle = (title: string, counter = ''): ((arg0: boolean) => React.ReactElement) =>
  getTitle(title)(counter)

function OverviewTab({children, className, unlimitedWidth, isClassic, ...restProps}: Props) {
  const classes = classNames(className, {
    [styles.limitedWidth]: !unlimitedWidth,
    [styles.classicTab]: isClassic,
  })
  return (
    <Tab {...restProps} className={classes}>
      {children}
    </Tab>
  )
}

export const createClassicUIOverviewTab = ({id, href, title}: CollapsibleTabProps) => {
  const {name, counter} = parseTabTitle(title)
  return (
    <CustomItem id={id} alwaysHidden key={stringifyId(id)}>
      <Link className={styles.link} href={href}>
        {() => (
          <div className={styles.linkContent}>
            <span className={styles.name}>{name}</span>
            {counter != null && <span className={styles.counter}>{counter}</span>}
            <ClassicTabMammoth />
          </div>
        )}
      </Link>
    </CustomItem>
  )
}
export default OverviewTab
